import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {computed} from "vue";
import {orderTypeDescription} from "@/shared/model/orderType";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import PersonDetailsId from "@/shared/model/personDetailsId";
import PersonDetails from "@/shared/model/personDetails";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import {useAccountStore} from "@/stores/accountStore";

interface Props {
  details?: PersonDetails
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PersonAcountingComponent',
  props: {
    details: { default: undefined }
  },
  setup(__props: any) {



const props = __props

const _accountStore = useAccountStore();

const _orderType = computed(() => {
  return orderTypeDescription(props.details?.getValue(PersonDetailsId.OrderTypeId));
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", null, [
      _withDirectives(_createElementVNode("tr", null, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("td", { colspan: "2" }, [
          _createElementVNode("span", { class: "e-badge e-badge-danger e-badge-pill" }, " Bestellmöglichkeit gesperrt")
        ], -1)
      ]))], 512), [
        [_vShow, __props.details?.getBooleanValue(_unref(PersonDetailsId).OrderingBlocking)]
      ]),
      _createElementVNode("tr", null, [
        _cache[1] || (_cache[1] = _createElementVNode("td", null, "Rechnungstyp", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, { value: _orderType.value }, null, 8, ["value"])
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[2] || (_cache[2] = _createElementVNode("td", null, "Rechnungsreferenznummer", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.details?.getValue(_unref(PersonDetailsId).InvoiceCircle)
          }, null, 8, ["value"])
        ])
      ]),
      _withDirectives(_createElementVNode("tr", null, [
        _cache[3] || (_cache[3] = _createElementVNode("td", null, "Rechnungs-Email", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.details?.getValue(_unref(PersonDetailsId).OrderEmail)
          }, null, 8, ["value"])
        ])
      ], 512), [
        [_vShow, _unref(_accountStore).hasAccountingLicense() && __props.details?.getValue(_unref(PersonDetailsId).OrderTypeId)]
      ]),
      _withDirectives(_createElementVNode("tr", null, [
        _cache[4] || (_cache[4] = _createElementVNode("td", null, "Kreditlimit", -1)),
        _createElementVNode("td", null, [
          _withDirectives(_createVNode(SogDataLabel, {
            value: __props.details?.getNumberValue(_unref(PersonDetailsId).CreditLimit),
            "value-type": _unref(SogDataLabelValueType).Money
          }, null, 8, ["value", "value-type"]), [
            [_vShow, !(__props.details?.getBooleanValue(_unref(PersonDetailsId).WithoutCreditLimit))]
          ]),
          _withDirectives(_createVNode(SogDataLabel, { value: "ohne" }, null, 512), [
            [_vShow, __props.details?.getBooleanValue(_unref(PersonDetailsId).WithoutCreditLimit)]
          ])
        ])
      ], 512), [
        [_vShow, _unref(_accountStore).hasAccountingLicense() && __props.details?.getValue(_unref(PersonDetailsId).OrderTypeId)]
      ]),
      _withDirectives(_createElementVNode("tr", null, [
        _cache[5] || (_cache[5] = _createElementVNode("td", null, "Automatische Stornoabrechnung", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.details?.getValue(_unref(PersonDetailsId).AutomaticCancelationInvoicing) === 'False' ? 'Nein' : 'Ja'
          }, null, 8, ["value"])
        ])
      ], 512), [
        [_vShow, __props.details?.getValue(_unref(PersonDetailsId).OrderTypeId) === 'AccumulativeInvoice']
      ]),
      _withDirectives(_createElementVNode("tr", null, [
        _cache[6] || (_cache[6] = _createElementVNode("td", null, "Stornogenehmigung ohne Bezahlung", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.details?.getValue(_unref(PersonDetailsId).CancellationAllowedWithoutPayment) === 'True' ? 'Ja' : 'Nein'
          }, null, 8, ["value"])
        ])
      ], 512), [
        [_vShow, __props.details?.getValue(_unref(PersonDetailsId).OrderTypeId) === 'AccumulativeInvoice']
      ]),
      _withDirectives(_createElementVNode("tr", null, [
        _cache[7] || (_cache[7] = _createElementVNode("td", null, "Rechnungsfälligkeit", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.details?.getValue(_unref(PersonDetailsId).InvoiceDueDate)
          }, null, 8, ["value"])
        ])
      ], 512), [
        [_vShow, __props.details?.getValue(_unref(PersonDetailsId).OrderTypeId)]
      ]),
      _withDirectives(_createElementVNode("tr", null, [
        _cache[8] || (_cache[8] = _createElementVNode("td", null, "Nächste Rechnung am", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.details?.getValue(_unref(PersonDetailsId).OrderScheduleNext),
            "value-type": _unref(SogDataLabelValueType).DateTime
          }, null, 8, ["value", "value-type"])
        ])
      ], 512), [
        [_vShow, __props.details?.getValue(_unref(PersonDetailsId).OrderTypeId) === 'AccumulativeInvoice']
      ])
    ])
  ]))
}
}

})